import { auth } from './firebase';

const BASE_URL = process.env.REACT_APP_FUNCTIONS_BASE_URL;

const authPost = async (endpoint, body) => {
  const token = auth.currentUser ? await auth.currentUser.getIdToken() : null;
  const res = await fetch(`${BASE_URL}/${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || err.error || `Request failed: ${res.status}`);
  }
  return res.json();
};

export const createPaymentIntent = async ({ amount, bookingId, currency = 'aud' }) => {
  if (!BASE_URL) throw new Error('Payment service not configured');
  return authPost('createPaymentIntent', { amount, bookingId, currency });
};
